import axios from 'axios'
var qs = require('qs')// {params: params}对提交json参数格式化a=212&b=2332的格式

// 配置默认值
// axios.defaults.baseURL = 'https://api.example.com';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';

// 超时时间
axios.defaults.timeout = 500000
axios.defaults.withCredentials = true
// http请求拦截器
// //添加请求拦截器
axios.interceptors.request.use(function(config){
    //在发送请求之前做某事
    return config;
},function(error){
    //请求错误时做些事
    return Promise.reject(error);
});
 
//添加响应拦截器
axios.interceptors.response.use(function(response){
    //对响应数据做些事
    return response;
},function(error){
    //请求错误时做些事
    return Promise.reject(error);
});

var instance = axios.create({
  baseURL: 'http://some-domain.com/api/',
  timeout: 1000,
  headers: { 'X-Custom-Header': 'foobar' }
})

// 生产环境
 const api = require('./index.js');
// 本地开发
//const api = require('./../../static/data/apiData.js');

const dfapi = api.default;
// console.log(dfapi);
// 图形验证码
 export const loginCodeImg = dfapi.loginCode;
// 登录
export const login = params => { return axios.post(dfapi.login, qs.stringify(params)).then(res => res.data) }
// 退出
export const logout = params => { return axios.post(dfapi.logout,  qs.stringify(params)).then(res => res.data) }
// 检查是否被注册
export const checkMobile = params => { return axios.post(dfapi.checkMobile, qs.stringify(params)).then(res => res.data) }
//注册第一步
export const regist = params => { return axios.post(dfapi.regist, qs.stringify(params)).then(res => res.data) }
export const register_two = params => { return axios.post(dfapi.register_two, qs.stringify(params)).then(res => res.data) }
export const register_three_1 = params => { return axios.post(dfapi.register_three_1, qs.stringify(params)).then(res => res.data) }
// 注册发送验证码
export const registCode = params => { return axios.post(dfapi.registCode,qs.stringify(params)).then(res => res.data) }
// 上传图片
export const upload = dfapi.upload
export const cutImg = dfapi.cutImg
// export const upload = params => { return axios.get(dfapi.upload, qs.stringify(params)).then(res => res.data) }
// 选择入住类型
export const crzType = params => { return axios.get(dfapi.crzType, {params: params}).then(res => res.data) }
// 入住信息
export const ruzhuType = params => { return axios.get(dfapi.ruzhuType, {params: params}).then(res => res.data) }
// 修改密码
export const EditPassword = params => { return axios.get(dfapi.EditPassword, {params: params}).then(res => res.data) }
// 获取文章列表
export const getmaininfo = params => { return axios.post(dfapi.getmaininfo, qs.stringify(params)).then(res => res.data) }
// 获取个人信息
export const getuserinfo = params => { return axios.post(dfapi.getuserinfo, qs.stringify(params)).then(res => res.data) }
// 获取阅读量评论量
//export const getPageview = params => { return axios.post(dfapi.getPageview, qs.stringify(params)).then(res => res.data) }
//获取评论和阅读
export const getPageview = params => {
    return axios({
      headers: {
        'Content-type': 'application/json;charset=UTF-8'
      },
      method: 'post',
      url: dfapi.getPageview,
      data: JSON.stringify(params)
    }).then(res => res.data)
  }
// 首页第一行统计数
export const datatotal = params => { return axios.get(dfapi.datatotal, {params: params}).then(res => res.data) }
// 推荐阅读
export const getContentRecommends = params => { return axios.get(dfapi.getContentRecommends, {params: params}).then(res => res.data) }
// 优质用户
export const getUserRecommends = params => { return axios.get(dfapi.getUserRecommends, {params: params}).then(res => res.data) }
// 阅读量异步加载接口
export const getReadPvRecommends = params => { return axios.get(dfapi.getReadPvRecommends, {params: params}).then(res => res.data) }
// 消息中心
export const getmessagelist = params => { return axios.post(dfapi.getmessagelist, qs.stringify(params)).then(res => res.data) }
// 增量对比
export const h5TabulateData = params => { return axios.get(dfapi.h5TabulateData, {params: params}).then(res => res.data) }
// 文章管理搜索接口
export const searchcontent = params => { return axios.post(dfapi.searchcontent, {params: params}).then(res => res.data) }
// 撤回文章
export const withdrawcontent = params => { return axios.post(dfapi.withdrawcontent, qs.stringify(params)).then(res => res.data) }
// 草稿删除文章
//export const deldraftlist = params => { return axios.post(dfapi.deldraftlist, qs.stringify(params)).then(res => res.data) }
export const deldraftlist = (urlData) => {
    return axios({
      method: 'post',
      url: dfapi.deldraftlist+urlData,
    }).then(res => res.data)
  }
// 删除文章
export const delcontent = params => { return axios.post(dfapi.delcontent, qs.stringify(params)).then(res => res.data) }
// 发布图集
export const atlasUpload = params => { return axios.get(dfapi.atlasUpload, {params: params}).then(res => res.data) }
// 发布视频
export const uploadVideo = params => { return axios.post(dfapi.uploadVideo, qs.stringify(params)).then(res => res.data) }
// 验证App
export const checkAppToken = params => { return axios.get(dfapi.checkAppToken, {params: params}).then(res => res.data) }
//数据分析查询
export const datasurvey = params => { return axios.post(dfapi.datasurvey, qs.stringify(params)).then(res => res.data) }
// 可发文章数量
export const getArticleCanPublish = params => { return axios.post(dfapi.getArticleCanPublish, qs.stringify(params)).then(res => res.data) }
export const insertImgUrl = () => { return dfapi.insertImgUrl}//文章内图片上传
export const originalImageUpload = () => { return dfapi.originalImageUpload}//文章封面上传
//文章发布
export const publishNewArticle = params => { 
  return axios({
    headers: {
      'Content-type': 'application/json;charset=UTF-8'
    },
    method: "post",
    url: dfapi.publishNewArticle,
    data: JSON.stringify(params)
  }).then(res => res.data)
}



// WEBPACK FOOTER //
// ./src/axios/api.js